import { call, put, takeEvery } from 'redux-saga/effects';
import { OEMSCANLIST_CONSTANTS } from '../constants/oemscanlistConstants';
import { getOemScanListSuccess, getOemScanListFailure ,getOemNamesByAlmataSuccess, getOemNamesByAlmataFailure, } from '../actions/oemscanlistAction';
import { getOemScanListApi,getOemNamesByAlmataApi } from '../../api/oemscanlistApi';

function* getOemScanListSaga(action) {
  try {
    const response = yield call(getOemScanListApi, action.payload);
    yield put(getOemScanListSuccess(response.data));
  } catch (error) {
    yield put(getOemScanListFailure(error.response?.data?.message || 'Failed to fetch OEM scan list'));
  }
}

function* getOemNamesByAlmataSaga(action) {
  try {
    const response = yield call(getOemNamesByAlmataApi, action.payload);
    yield put(getOemNamesByAlmataSuccess(response.data?.response || []));
  } catch (error) {
    yield put(getOemNamesByAlmataFailure(error.response?.data?.message || 'Failed to fetch OEM names'));
  }
}
function* oemscanlistSaga() {
  yield takeEvery(OEMSCANLIST_CONSTANTS.GET_OEM_SCAN_LIST_REQUEST, getOemScanListSaga);
  yield takeEvery(OEMSCANLIST_CONSTANTS.GET_OEM_NAMES_BY_ALMATA_REQUEST, getOemNamesByAlmataSaga);
  
}

export default oemscanlistSaga;
